import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

type Props = {
  speed?: number;
} & React.ComponentProps<"div">;

const LoadingBar = (props: Props) => {
  const { speed, ...rest } = props;
  return (
    <Progress speed={speed} {...rest}>
      <ProgressIndeterminate />
    </Progress>
  );
};

const ProgressIndeterminate = styled.div``;

const indeterminateKeyFrames = keyframes`
    0% {
      left: -35%;
      right: 100%;
    }
    60% {
      left: 100%;
      right: -90%;
    }
    100% {
      left: 100%;
      right: -90%;
    }
`;

const indeterminateKeyFramesShort = keyframes`
    0% {
        left: -200%;
        right: 100%;
    }
    60% {
        left: 107%;
        right: -8%;
    }
    100% {
        left: 107%;
        right: -8%;
    }
`;

const Progress = styled.div<{ speed?: number }>`
  position: relative;
  height: 4px;
  display: block;
  width: 100%;
  background-color: #bbdefb;
  border-radius: 2px;
  background-clip: padding-box;
  overflow: hidden;

  ${ProgressIndeterminate} {
    background-color: #0977e6;
  }

  ${ProgressIndeterminate}:before {
    content: "";
    position: absolute;
    background-color: inherit;
    top: 0;
    left: 0;
    bottom: 0;
    will-change: left, right;
    animation: ${indeterminateKeyFrames} ${(props) => props.speed ?? 1}s
      cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
  }

  ${ProgressIndeterminate}:after {
    content: "";
    position: absolute;
    background-color: inherit;
    top: 0;
    left: 0;
    bottom: 0;
    will-change: left, right;
    animation: ${indeterminateKeyFramesShort} ${(props) => props.speed ?? 1}s
      cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
    animation-delay: 1.15s;
  }
`;

export default LoadingBar;
